<nav class="navbar navbar-expand-lg navbar-light bg-light">
	<a class="navbar-brand" href="#"><img src="/assets/imgs/01_CHP_Aluche_logo.png" width="50" height="50" alt=""></a> 
	<a class="navbar-brand" href="#">CHP Aluche</a>
	
	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button>
	
	<div class="collapse navbar-collapse" id="navbarNavDropdown">
		<ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" routerLink="competicionesFMP" data-toggle="collapse" data-target=".navbar-collapse.show">Competiciones</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="entrenamientos" data-toggle="collapse" data-target=".navbar-collapse.show">Entrenamientos</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="agenda" data-toggle="collapse" data-target=".navbar-collapse.show">Agenda</a>
            </li>
            <li class="nav-item" *ngIf="!user && !mobile">
                <a class="nav-link" routerLink="login">Login</a>
            </li>
            <li class="nav-item dropdown" *ngIf="user"> 
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Catalogos
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
					<a class="dropdown-item" routerLink="temporadas" data-toggle="collapse" data-target=".navbar-collapse.show">Temporadas</a>
					<a class="dropdown-item" routerLink="categorias" data-toggle="collapse" data-target=".navbar-collapse.show">Categorias</a>
					<div class="dropdown-divider"></div>
                    <a class="dropdown-item" routerLink="equipos" data-toggle="collapse" data-target=".navbar-collapse.show">Equipos Aluche</a>
                    <a class="dropdown-item" routerLink="competiciones" data-toggle="collapse" data-target=".navbar-collapse.show">Competiciones</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" routerLink="roles" data-toggle="collapse" data-target=".navbar-collapse.show">Roles</a>
                    <a class="dropdown-item" routerLink="usuarios" data-toggle="collapse" data-target=".navbar-collapse.show">Usuarios</a>
                </div>
            </li>
		</ul>

        <div class="my-2 my-lg-0" *ngIf="user">
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>{{ user.email }}</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="logout()">Logout</button>
                </div>
            </div>
        </div>
    </div>
</nav>